import { GetStaticProps } from 'next';
import { EfroOostHomePageFieldsFragment, EfroOostInformationFieldsFragment } from 'api/graphql-types';
import Layout from 'modules/layout/layout';
import { ModuleBuilder } from 'modules/module-builder/module-builder';
import client, { httpLink, setPreviewSecret } from 'api/apollo-client';
import { getServerPageGetEfroOostHome } from 'api/graphql-helper';
import { initialState as settingsInitialState } from 'redux/stores/settings';
import { Head } from 'modules/head/head';
import { getStrapiParametersFromContext } from 'utils/strapi-parameters';
import HomepageHeader from 'modules/homepage-header/homepage-header';
import { ROUTES } from 'constants/routes';
import { IBasePageProps } from 'types/page';

interface IOpOostPageProps extends IBasePageProps {
	efroOostHomepage?: EfroOostHomePageFieldsFragment;
	efroOostInformation?: EfroOostInformationFieldsFragment;
}

const EfroOostHomePage = (props: IOpOostPageProps): React.JSX.Element => {
	const modules = props.efroOostHomepage?.modules;
	const seoModule = props?.efroOostHomepage?.seo;

	return (
		<Layout navbar={props?.efroOostInformation?.navbar} footer={props?.efroOostInformation?.footer}>
			<Head seoModule={seoModule} seoParent={props?.efroOostInformation?.seo} />
			<HomepageHeader module={props?.efroOostHomepage?.header} />
			<ModuleBuilder modules={modules} slug={ROUTES.HOME.fullPath} />
		</Layout>
	);
};

export const getStaticProps: GetStaticProps<IBasePageProps> = async (ctx) => {
	try {
		const { locale, publicationState, draftMode } = getStrapiParametersFromContext(ctx);

		if (publicationState === 'DRAFT') {
			client.setLink(setPreviewSecret(process.env.STRAPI_PREVIEW_SECRET as string).concat(httpLink));
		}

		const efroOostHomePageResult = await getServerPageGetEfroOostHome(
			{
				variables: {
					locale,
					publicationState
				}
			},
			client
		);
		const { efroOostHomepage, efroOostInformation } = efroOostHomePageResult.props.data;

		if (efroOostHomepage == null) {
			return {
				notFound: true
			};
		}

		return {
			props: {
				efroOostHomepage: efroOostHomepage.data?.attributes,
				efroOostInformation: efroOostInformation?.data?.attributes,
				initialReduxState: {
					settings: {
						...settingsInitialState,
						publicationState,
						draftMode,
						contentType: 'efro-oost-homepage',
						contentTypeId: efroOostHomepage?.data?.documentId,
						showNeutralStyle: true,
						hideLanguageSwitcher: true,
						hideSearchbar: false,
						isSubsite: true
					}
				}
			},
			revalidate: Number(process.env.NEXT_PUBLIC_REVALIDATE_TIME_IN_SECONDS)
		};
	} catch (error: any) {
		// eslint-disable-next-line no-console
		console.error('error in EfroOostHomePage', error);
		return {
			notFound: true
		};
	}
};

export default EfroOostHomePage;
